import { useEffect, useState } from "react";
import { documentId, onSnapshot, query, where } from "firebase/firestore";
import { useAuth } from "../../contexts/AuthContext";
import { roles } from "../../firebase.collection";
import NotesTabTherapist from "../Notes/NotesTabTherapist";
import NotesTabNonTherapist from "../Notes/NotesTabNonTherapist";
import NotesTabTherapistForMedicalStaff from "../Notes/NotesTabTherapistForMedicalStaff";
import NotesTabTherapistForHospitality from "../Notes/NotesTabTherapistForHospitality";

function ClientNotes(props) {
  //VARIABLES

  const { currentUser } = useAuth();
  const userIdState = currentUser ? currentUser.uid : "";

  //STATES

  const [userRole, setUserRole] = useState("");

  //FUNCTIONS

  function queryRole() {
    onSnapshot(
      query(roles, where(documentId(), "==", userIdState)),
      (querySnapshot) => {
        const doc = querySnapshot.docs[0];
        if (doc && doc.exists) {
          const role = doc.data().role;

          setUserRole(role);
        } else {
          console.log("No role for this user");
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
      }
    );
  }

  useEffect(() => {
    if (currentUser) {
      queryRole();
    } else {
      console.log("No user id");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentUser]);

  return (
    <div className="tab-form-container">
      {(() => {
        if (
          userRole === "Therapist" ||
          userRole === "Super Admin" ||
          userRole === "Clinical Director"
        ) {
          return <NotesTabTherapist {...props} />;
        } else if (userRole === "Medical Staff") {
          return <NotesTabTherapistForMedicalStaff {...props} />;
        } else if (userRole === "Hospitality Staff") {
          return <NotesTabTherapistForHospitality {...props} />;
        } else {
          return <NotesTabNonTherapist {...props} />;
        }
      })()}
    </div>
  );
}

export default ClientNotes;
